import { useGeneratorStore, type GeneratorStep } from './generatorStore';
import ThemeStep from './steps/ThemeStep';
import ConfigStep from './steps/ConfigStep';
import StyleReferenceStep from './steps/StyleReferenceStep';
import GeneratingStep from './steps/GeneratingStep';
import DoneStep from './steps/DoneStep';

const stepOrder: GeneratorStep[] = ['theme', 'config', 'style', 'generating', 'done'];

const stepLabels: Record<GeneratorStep, string> = {
  theme: '主题',
  config: '配置',
  style: '风格',
  generating: '生成',
  done: '完成',
};

export default function AiGenerator() {
  const { step, setStep } = useGeneratorStore();
  const currentIndex = stepOrder.indexOf(step);

  const renderStep = () => {
    switch (step) {
      case 'theme':
        return <ThemeStep />;
      case 'config':
        return <ConfigStep />;
      case 'style':
        return <StyleReferenceStep />;
      case 'generating':
        return <GeneratingStep />;
      case 'done':
        return <DoneStep />;
      default:
        return <ThemeStep />;
    }
  };

  return (
    <div style={rootStyle}>
      <div style={contentStyle}>{renderStep()}</div>

      <div style={navBarStyle}>
        <div style={stepsRowStyle}>
          {stepOrder.map((s, i) => {
            const isActive = i === currentIndex;
            const isPast = i < currentIndex;
            const clickable = isPast;
            return (
              <div key={s} style={stepItemStyle}>
                <button
                  onClick={() => {
                    if (clickable) setStep(s);
                  }}
                  disabled={!clickable}
                  style={{
                    ...dotStyle,
                    background: isActive
                      ? 'linear-gradient(135deg, #7c4dff, #448aff)'
                      : isPast
                        ? 'rgba(124,77,255,0.4)'
                        : 'rgba(255,255,255,0.1)',
                    cursor: clickable ? 'pointer' : 'default',
                  }}
                >
                  {isPast ? '\u{2713}' : i + 1}
                </button>
                <span
                  style={{
                    ...labelStyle,
                    color: isActive ? '#fff' : 'rgba(255,255,255,0.4)',
                  }}
                >
                  {stepLabels[s]}
                </span>
                {i < stepOrder.length - 1 && <div style={lineStyle} />}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const rootStyle: React.CSSProperties = {
  width: '100vw',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  background: 'linear-gradient(180deg, #0d1030 0%, #1a1a3e 50%, #0d1030 100%)',
  color: '#fff',
  overflow: 'auto',
};

const contentStyle: React.CSSProperties = {
  flex: 1,
  paddingBottom: '100px',
};

const navBarStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: 'rgba(13,16,48,0.85)',
  backdropFilter: 'blur(12px)',
  borderTop: '1px solid rgba(255,255,255,0.08)',
  padding: '16px 20px',
  zIndex: 50,
};

const stepsRowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0',
  maxWidth: '500px',
  margin: '0 auto',
};

const stepItemStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

const dotStyle: React.CSSProperties = {
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  border: 'none',
  color: '#fff',
  fontSize: '12px',
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

const labelStyle: React.CSSProperties = {
  fontSize: '12px',
  whiteSpace: 'nowrap',
};

const lineStyle: React.CSSProperties = {
  width: '24px',
  height: '1px',
  background: 'rgba(255,255,255,0.15)',
  margin: '0 4px',
};
